// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Invoice_upper__Gd2b\\+ {
  display: grid;
  grid-template-columns: 72rem 1.5fr;
  gap: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Invoice_upper__Gd2b\\+ {
    grid-template-columns: 60rem 1fr;
  }
}
@media only screen and (max-width: 56.25em) {
  .Invoice_upper__Gd2b\\+ {
    grid-template-columns: 100%;
  }
}
.Invoice_upper__ql__R8j39 {
  width: 100%;
  border-radius: 2rem;
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 3.5rem 2rem;
  height: -moz-fit-content;
  height: fit-content;
  align-self: center;
}
@media only screen and (max-width: 56.25em) {
  .Invoice_upper__ql__R8j39 {
    width: 95%;
    justify-self: center;
  }
}
.Invoice_upper__ql__content__Ac5yB {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  box-sizing: border-box;
  gap: 2rem;
  margin-top: 3rem;
}
.Invoice_upper__multiple__aD\\+dh {
  display: flex;
  flex-direction: column;
  border-radius: 2rem;
  background-color: var(--color-white);
  padding: 2rem;
}
.Invoice_upper__metrics__OlEPO {
  box-sizing: border-box;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-bottom: 1rem;
}
@media only screen and (max-width: 62.5em) {
  .Invoice_upper__metrics__OlEPO {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (max-width: 56.25em) {
  .Invoice_upper__metrics__OlEPO {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 37.5em) {
  .Invoice_upper__metrics__OlEPO {
    grid-template-columns: repeat(2, 1fr);
  }
}

.Invoice_searchInMiddle__x2bdb {
  display: flex;
  width: 100%;
  justify-content: center;
}

.Invoice_invoice__list__n37TC {
  margin-top: 2rem;
  display: flex;
  position: relative;
}
.Invoice_invoice__beside__y1ZH6 {
  display: flex;
  justify-content: space-between;
  width: 38rem;
  flex-wrap: wrap;
}
.Invoice_invoice__checks__2myL2 {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
  width: 38rem;
}
.Invoice_invoice__checks_group__c5Apd {
  align-self: center;
  width: 100%;
}

.Invoice_table__qu7ns {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  font-size: var(--default-font-small);
}
.Invoice_table__qu7ns th,
.Invoice_table__qu7ns td {
  padding: 2.2rem 0;
}
.Invoice_table__qu7ns th {
  font-weight: 700;
}
.Invoice_table__qu7ns tr {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 7rem 1fr 1fr;
  padding: 0 3rem;
}
@media only screen and (max-width: 37.5em) {
  .Invoice_table__qu7ns tr {
    grid-template-columns: 20% 50% 30%;
  }
}
.Invoice_table__qu7ns tbody > :not(:last-child) {
  margin-bottom: 1.5rem;
}
.Invoice_table__qu7ns tbody tr {
  background-color: var(--color-primary-3);
  border-radius: 1.3rem;
}
.Invoice_table__qu7ns tbody tr:nth-child(even) {
  background-color: var(--color-primary-7);
}
.Invoice_table__qu7ns tbody tr > :last-child {
  display: flex;
  justify-content: space-between;
  font-size: var(--default-font-size);
}
@media only screen and (max-width: 37.5em) {
  .Invoice_table__qu7ns tbody tr > :last-child {
    font-size: var(--default-font-small);
  }
}
.Invoice_table__qu7ns tbody tr > :last-child > * {
  cursor: pointer;
}
.Invoice_table__qu7ns tbody tr > :last-child > *:hover {
  color: var(--color-primary);
}
.Invoice_table__qu7ns tbody tr > :nth-child(5) {
  font-size: 3rem;
  position: relative;
}
.Invoice_table__qu7ns tbody tr > :nth-child(5) span {
  font-size: 1.2rem;
  width: -moz-fit-content;
  width: fit-content;
  background-color: rgba(0, 0, 0, 0.75);
  color: var(--color-white);
  position: absolute;
  padding: 0.5rem;
  left: -1.6rem;
  border-radius: 0.5rem;
  text-align: center;
  opacity: 0;
  cursor: pointer;
}
.Invoice_table__qu7ns tbody tr > :nth-child(5) span:hover {
  opacity: 1;
}

.Invoice_notPaid__kPzdw {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-error);
  color: var(--color-white);
  margin-bottom: 1rem;
  width: 83%;
}

.Invoice_draft__bcJ1M {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-error);
  color: var(--color-white);
  margin-bottom: 1rem;
  width: 83%;
  position: relative;
  top: 1rem;
}

.Invoice_partPaid__Gib1L {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-yellow);
  color: var(--color-dark);
  margin-bottom: 1rem;
  width: 83%;
}

.Invoice_expired__SvxXR {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-yellow);
  color: var(--color-dark);
  margin-bottom: 1rem;
  width: 83%;
}

.Invoice_paid__5IJo7 {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-green);
  color: var(--color-white);
  margin-bottom: 1rem;
  width: 83%;
}

.Invoice_ordered__QN3dd {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-green);
  color: var(--color-white);
  margin-bottom: 1rem;
  width: 83%;
}

.Invoice_minMenu__\\+h1v9 {
  color: var(--color-primary);
  cursor: pointer;
  font-size: 2rem;
}

.Invoice_sideButton__Kw1Hr {
  display: flex;
  margin-top: 3rem;
}

.Invoice_summary__nH3v3 {
  width: 42rem;
  margin-top: 2rem;
}
.Invoice_summary__title__z2RZ- {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Invoice_summary__initials__CyNRq {
  display: flex;
  background-color: var(--color-fash-primary);
  font-size: var(--default-font-h3);
  font-weight: 700;
  width: 8rem;
  height: 8rem;
  border-radius: 8rem;
  justify-content: center;
  align-items: center;
}
.Invoice_summary__edit__PFPlo {
  display: flex;
  align-items: flex-end;
  color: var(--color-dark);
  font-size: var(--default-font-small);
  cursor: pointer;
  margin-bottom: 3rem;
}
.Invoice_summary__edit__PFPlo > :last-child {
  font-size: 3rem;
  color: var(--color-fash-primary-3);
}
.Invoice_summary__edit__PFPlo:hover, .Invoice_summary__edit__PFPlo:focus {
  color: var(--color-fash-primary-2);
  font-weight: 700;
}
.Invoice_summary__line__rhEwO {
  border-top: 1px solid var(--color-dark);
  margin: 2rem 0;
}
.Invoice_summary__dates__N0WSr {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}
.Invoice_summary__dates__N0WSr > :not(:last-child) {
  margin-right: 2rem;
}
.Invoice_summary__total__ub4r8 {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 2rem;
  margin-bottom: 1rem;
}
.Invoice_summary__account__gM4RU {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 1rem;
  margin: 2rem 0;
}
.Invoice_summary__button__thaN5 {
  display: flex;
  gap: 2rem;
  align-items: center;
  margin-top: 2rem;
}

.Invoice_error__dIf0C {
  font-size: var(--default-font-small);
  color: var(--color-error);
  padding-left: 2rem;
  font-weight: 400;
  margin: 1rem 0;
}

.Invoice_select__ww0bi {
  display: grid;
  grid-template-columns: 1fr 1fr;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  width: 38rem;
  margin-bottom: 3rem;
  cursor: pointer;
}
.Invoice_select__ww0bi > * {
  padding: 1rem 0 1rem 0;
  text-align: center;
}
.Invoice_select__invoice__qyUTR {
  background-color: var(--color-primary);
  color: var(--color-white);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.Invoice_select__invoice_b__MV0t8 {
  border: 1px solid var(--color-primary);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.Invoice_select__receipt__n\\+Ypx {
  border: 1px solid var(--color-primary);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}
.Invoice_select__receipt_b__WC\\+1\\+ {
  background-color: var(--color-primary);
  color: var(--color-white);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}

.Invoice_selectCurrency__8og0S {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: var(--default-font-small);
  position: relative;
  margin-left: 2rem;
}
.Invoice_selectCurrency__text__7qDkA {
  display: flex;
  margin-left: 1rem;
}
.Invoice_selectCurrency__icon__iU24h {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transform: rotateZ(0);
  transition-duration: 500ms;
}
.Invoice_selectCurrency__icon__iU24h:hover {
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.Invoice_selectCurrency__icon_active__V7B9V {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transition-duration: 500ms;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.Invoice_selectCurrency__list__KoU7o {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 5rem;
  background-color: #f2f0f0;
  color: var(--color-dark);
  border-radius: 1rem;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  position: absolute;
  top: 6rem;
  z-index: 30;
  border: solid 1px var(--color-primary-4);
}
.Invoice_selectCurrency__list_active__9BL9c {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}
.Invoice_selectCurrency__list__KoU7o li {
  list-style: none;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 1rem 0;
  box-sizing: border-box;
  border-radius: 1rem;
  cursor: pointer;
}
.Invoice_selectCurrency__list__KoU7o li:hover {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}

.Invoice_main__xpYD\\+ {
  display: grid;
  grid-template-columns: 72rem 1fr;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  gap: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Invoice_main__xpYD\\+ {
    grid-template-columns: 56rem 1fr;
  }
}
@media only screen and (max-width: 43.75em) {
  .Invoice_main__xpYD\\+ {
    grid-template-columns: 100%;
  }
}
.Invoice_main_nav__aBLu\\+ {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 2rem;
  padding: 0 2rem;
  background-color: var(--color-white);
  border-bottom: solid 1px var(--color-dark);
  border-radius: 1rem 1rem 0 0;
}
.Invoice_main_nav__aBLu\\+ > :not(:last-child) {
  margin-right: 3rem;
}
.Invoice_main_nav_group__Ui7tJ {
  position: relative;
}
.Invoice_main_nav_more__JU6Hi {
  position: absolute;
  right: 0;
  top: 75%;
  background-color: var(--color-white);
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  z-index: 5;
}
.Invoice_main_nav_more__JU6Hi > :not(last-child) {
  margin-bottom: 1rem;
}
.Invoice_main_nav_item__PdYIx {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
}
.Invoice_main_nav_item_active__ruq3t {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  font-weight: 700;
  color: var(--color-fash-primary-3);
  border-bottom: solid 2px var(--color-fash-primary-3);
}
.Invoice_main_nav_item__PdYIx:hover, .Invoice_main_nav_item__PdYIx:focus, .Invoice_main_nav_item__PdYIx:focus-visible, .Invoice_main_nav_item__PdYIx:focus-within {
  font-weight: 700;
  color: var(--color-fash-primary-3);
  border-bottom: solid 2px var(--color-fash-primary-3);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Invoice/Invoice.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,kCAAA;EACA,SAAA;AADF;AAGE;EALF;IAMI,gCAAA;EAAF;AACF;AAEE;EATF;IAUI,2BAAA;EACF;AACF;AAOE;EACE,WAAA;EACA,mBAAA;EACA,oCAAA;EACA,4CAAA;EACA,sBAAA;EACA,oBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,kBAAA;AALJ;AAOI;EAVF;IAWI,UAAA;IACA,oBAAA;EAJJ;AACF;AAMI;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAJN;AAQE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;AANJ;AASE;EACE,sBAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AAPJ;AASI;EARF;IASI,qCAAA;EANJ;AACF;AAQI;EAZF;IAaI,qCAAA;EALJ;AACF;AAOI;EAhBF;IAiBI,qCAAA;EAJJ;AACF;;AAwCA;EACE,aAAA;EACA,WAAA;EACA,uBAAA;AArCF;;AAyCE;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;AAtCJ;AAyCE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;AAvCJ;AA0CE;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,YAAA;AAxCJ;AA0CI;EACE,kBAAA;EACA,WAAA;AAxCN;;AA0DA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;AAvDF;AAyDE;;EAEE,iBAAA;AAvDJ;AA0DE;EACE,gBAAA;AAxDJ;AA2DE;EACE,aAAA;EACA,mDAAA;EACA,eAAA;AAzDJ;AA2DI;EALF;IAMI,kCAAA;EAxDJ;AACF;AA4DI;EACE,qBAAA;AA1DN;AA6DI;EACE,wCAAA;EACA,qBAAA;AA3DN;AA6DM;EACE,wCAAA;AA3DR;AA8DM;EACE,aAAA;EACA,8BAAA;EACA,mCAAA;AA5DR;AA6DQ;EAJF;IAKI,oCAAA;EA1DR;AACF;AA4DQ;EACE,eAAA;AA1DV;AA2DU;EACE,2BAAA;AAzDZ;AA8DM;EAWE,eAAA;EACA,kBAAA;AAtER;AAwEQ;EACE,iBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,qCAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AAtEV;AAwEU;EACE,UAAA;AAtEZ;;AA8EA;EACE,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;AA3EF;;AA+EA;EACE,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;AA5EF;;AA+EA;EACE,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,qCAAA;EACA,wBAAA;EACA,mBAAA;EACA,UAAA;AA5EF;;AA8EA;EACE,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,qCAAA;EACA,wBAAA;EACA,mBAAA;EACA,UAAA;AA3EF;;AA8EA;EACE,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;AA3EF;;AA6EA;EACE,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;AA1EF;;AA6EA;EACE,2BAAA;EACA,eAAA;EACA,eAAA;AA1EF;;AA8EA;EACE,aAAA;EACA,gBAAA;AA3EF;;AA+EA;EACE,YAAA;EACA,gBAAA;AA5EF;AA6EE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AA3EJ;AA8EE;EACE,aAAA;EACA,2CAAA;EACA,iCAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AA5EJ;AA+EE;EACE,aAAA;EACA,qBAAA;EACA,wBAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;AA7EJ;AA+EI;EACE,eAAA;EACA,kCAAA;AA7EN;AAgFI;EAEE,kCAAA;EACA,gBAAA;AA/EN;AAmFE;EACE,uCAAA;EACA,cAAA;AAjFJ;AAoFE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAlFJ;AAmFI;EACE,kBAAA;AAjFN;AAqFE;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,mBAAA;AAnFJ;AAsFE;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,cAAA;AApFJ;AAuFE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AArFJ;;AA2FA;EACE,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAxFF;;AA2FA;EACE,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,oCAAA;EACA,YAAA;EAEA,mBAAA;EACA,eAAA;AAzFF;AA2FE;EACE,sBAAA;EACA,kBAAA;AAzFJ;AA4FE;EACE,sCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AA1FJ;AA4FI;EACE,sCAAA;EACA,4BAAA;EACA,oBAAA;AA1FN;AA8FE;EACE,sCAAA;EACA,4BAAA;EACA,oBAAA;AA5FJ;AA8FI;EACE,sCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AA5FN;;AAiGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AA9FF;AAgGE;EACE,aAAA;EACA,iBAAA;AA9FJ;AAiGE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;AA/FJ;AAiGI;EACE,4DACE;EAEF,wCAAA;EACA,2BAAA;AAjGN;AAoGI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,0BAAA;EACA,4DACE;EAEF,wCAAA;EACA,2BAAA;AApGN;AAwGE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;EACA,4DACE;EAEF,kBAAA;EACA,SAAA;EACA,WAAA;EACA,wCAAA;AAxGJ;AA0GI;EACE,wCAAA;EACA,2BAAA;EACA,gBAAA;AAxGN;AA2GI;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAzGN;AA2GM;EACE,wCAAA;EACA,2BAAA;EACA,gBAAA;AAzGR;;AA+GA;EACE,aAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,SAAA;AA5GF;AA8GE;EARF;IASI,gCAAA;EA3GF;AACF;AA6GE;EAZF;IAaI,2BAAA;EA1GF;AACF;AA4GE;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EAEA,oCAAA;EACA,0CAAA;EACA,4BAAA;AA3GJ;AA6GI;EACE,kBAAA;AA3GN;AA8GI;EACE,kBAAA;AA5GN;AA+GI;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;EACA,UAAA;AA7GN;AA+GM;EACE,mBAAA;AA7GR;AAiHI;EACE,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;AA/GN;AAqHM;EACE,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;EACA,gBAAA;EACA,kCAAA;EACA,oDAAA;AAnHR;AAsHM;EAIE,gBAAA;EACA,kCAAA;EACA,oDAAA;AAvHR","sourcesContent":["@import \"../variables/breakpoints\";\n\n.upper {\n  display: grid;\n  grid-template-columns: 72rem 1.5fr;\n  gap: 2rem;\n\n  @media only screen and (max-width: $bp-1000) {\n    grid-template-columns: 60rem 1fr;\n  }\n\n  @media only screen and (max-width: $bp-900) {\n    grid-template-columns: 100%;\n  }\n\n  // &__search {\n  // \tgrid-column: 1/3;\n  // \tgrid-row: 1/2;\n  // \tjustify-self: center;\n  // }\n\n  &__ql {\n    width: 100%;\n    border-radius: 2rem;\n    background-color: var(--color-white);\n    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n    box-sizing: border-box;\n    padding: 3.5rem 2rem;\n    height: fit-content;\n    align-self: center;\n\n    @media only screen and (max-width: $bp-900) {\n      width: 95%;\n      justify-self: center;\n    }\n\n    &__content {\n      display: flex;\n      flex-direction: column;\n      justify-content: space-evenly;\n      box-sizing: border-box;\n      gap: 2rem;\n      margin-top: 3rem;\n    }\n  }\n\n  &__multiple {\n    display: flex;\n    flex-direction: column;\n    border-radius: 2rem;\n    background-color: var(--color-white);\n    padding: 2rem;\n  }\n\n  &__metrics {\n    box-sizing: border-box;\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 2rem;\n    margin-bottom: 1rem;\n\n    @media only screen and (max-width: $bp-1000) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    @media only screen and (max-width: $bp-900) {\n      grid-template-columns: repeat(3, 1fr);\n    }\n\n    @media only screen and (max-width: $bp-600) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    // &_paid {\n    //   background-color: var(--color-green);\n    //   color: var(--color-white);\n    // }\n\n    // &_unpaid {\n    //   background-color: var(--color-error);\n    //   color: var(--color-white);\n    // }\n\n    // &_partPaid {\n    //   background-color: var(--color-yellow);\n    // }\n\n    // &_vat {\n    //   background-color: var(--color-light-red);\n    // }\n\n    // &_discount {\n    //   background-color: var(--color-primary-7);\n    // }\n\n    // &_due {\n    //   background-color: var(--color-error);\n    //   color: var(--color-white);\n    // }\n\n    // &_owe {\n    //   background-color: var(--color-error);\n    //   color: var(--color-white);\n    // }\n  }\n}\n\n.searchInMiddle {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n}\n\n.invoice {\n  &__list {\n    margin-top: 2rem;\n    display: flex;\n    position: relative;\n  }\n\n  &__beside {\n    display: flex;\n    justify-content: space-between;\n    width: 38rem;\n    flex-wrap: wrap;\n  }\n\n  &__checks {\n    display: flex;\n    justify-content: space-between;\n    margin: 1rem 0 2rem 0;\n    width: 38rem;\n\n    &_group {\n      align-self: center;\n      width: 100%;\n    }\n  }\n}\n\n// .status {\n// \tcontent: none;\n// \twidth: 50%;\n// \tborder-radius: 1rem;\n// \tbackground-color: var(--color-yellow);\n// \tjustify-self: center;\n// \talign-self: center;\n// \tpadding: 3rem;\n// \tdisplay: block;\n// }\n\n//Table styles start\n\n.table {\n  width: 100%;\n  max-width: 100%;\n  border: none;\n  border-collapse: collapse;\n  box-sizing: border-box;\n  text-align: left;\n  font-size: var(--default-font-small);\n\n  th,\n  td {\n    padding: 2.2rem 0;\n  }\n\n  th {\n    font-weight: 700;\n  }\n\n  tr {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr 7rem 1fr 1fr;\n    padding: 0 3rem;\n\n    @media only screen and (max-width: $bp-600) {\n      grid-template-columns: 20% 50% 30%;\n    }\n  }\n\n  tbody {\n    & > :not(:last-child) {\n      margin-bottom: 1.5rem;\n    }\n\n    tr {\n      background-color: var(--color-primary-3);\n      border-radius: 1.3rem;\n\n      &:nth-child(even) {\n        background-color: var(--color-primary-7);\n      }\n\n      & > :last-child {\n        display: flex;\n        justify-content: space-between;\n        font-size: var(--default-font-size);\n        @media only screen and (max-width: $bp-600) {\n          font-size: var(--default-font-small);\n        }\n\n        & > * {\n          cursor: pointer;\n          &:hover {\n            color: var(--color-primary);\n          }\n        }\n      }\n\n      & > :nth-child(5) {\n        // content: none;\n        // width: 3rem;\n        // height: 3rem;\n        // border-radius: 0.8rem;\n\n        // justify-self: center;\n        // align-self: center;\n        // padding: 0;\n        // margin-left: -2rem;\n\n        font-size: 3rem;\n        position: relative;\n\n        span {\n          font-size: 1.2rem;\n          width: fit-content;\n          background-color: rgba(0, 0, 0, 0.75);\n          color: var(--color-white);\n          position: absolute;\n          padding: 0.5rem;\n          left: -1.6rem;\n          border-radius: 0.5rem;\n          text-align: center;\n          opacity: 0;\n          cursor: pointer;\n\n          &:hover {\n            opacity: 1;\n          }\n        }\n      }\n    }\n  }\n}\n\n.notPaid {\n  display: inline-flex;\n  justify-content: center;\n  line-height: 1;\n  font-size: 1rem;\n  border-radius: 1rem;\n  background-color: var(--color-error);\n  color: var(--color-white);\n  margin-bottom: 1rem;\n  width: 83%;\n  // position: relative;\n  // top: 1rem;\n}\n.draft {\n  display: inline-flex;\n  justify-content: center;\n  line-height: 1;\n  font-size: 1rem;\n  border-radius: 1rem;\n  background-color: var(--color-error);\n  color: var(--color-white);\n  margin-bottom: 1rem;\n  width: 83%;\n  position: relative;\n  top: 1rem;\n}\n\n.partPaid {\n  display: inline-flex;\n  justify-content: center;\n  line-height: 1;\n  font-size: 1rem;\n  border-radius: 1rem;\n  background-color: var(--color-yellow);\n  color: var(--color-dark);\n  margin-bottom: 1rem;\n  width: 83%;\n}\n.expired {\n  display: inline-flex;\n  justify-content: center;\n  line-height: 1;\n  font-size: 1rem;\n  border-radius: 1rem;\n  background-color: var(--color-yellow);\n  color: var(--color-dark);\n  margin-bottom: 1rem;\n  width: 83%;\n}\n\n.paid {\n  display: inline-flex;\n  justify-content: center;\n  line-height: 1;\n  font-size: 1rem;\n  border-radius: 1rem;\n  background-color: var(--color-green);\n  color: var(--color-white);\n  margin-bottom: 1rem;\n  width: 83%;\n}\n.ordered {\n  display: inline-flex;\n  justify-content: center;\n  line-height: 1;\n  font-size: 1rem;\n  border-radius: 1rem;\n  background-color: var(--color-green);\n  color: var(--color-white);\n  margin-bottom: 1rem;\n  width: 83%;\n}\n\n.minMenu {\n  color: var(--color-primary);\n  cursor: pointer;\n  font-size: 2rem;\n}\n//Table styles end\n\n.sideButton {\n  display: flex;\n  margin-top: 3rem;\n}\n\n//Summary Styles\n.summary {\n  width: 42rem;\n  margin-top: 2rem;\n  &__title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  &__initials {\n    display: flex;\n    background-color: var(--color-fash-primary);\n    font-size: var(--default-font-h3);\n    font-weight: 700;\n    width: 8rem;\n    height: 8rem;\n    border-radius: 8rem;\n    justify-content: center;\n    align-items: center;\n  }\n\n  &__edit {\n    display: flex;\n    align-items: flex-end;\n    color: var(--color-dark);\n    font-size: var(--default-font-small);\n    cursor: pointer;\n    margin-bottom: 3rem;\n\n    & > :last-child {\n      font-size: 3rem;\n      color: var(--color-fash-primary-3);\n    }\n\n    &:hover,\n    &:focus {\n      color: var(--color-fash-primary-2);\n      font-weight: 700;\n    }\n  }\n\n  &__line {\n    border-top: 1px solid var(--color-dark);\n    margin: 2rem 0;\n  }\n\n  &__dates {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 2rem;\n    & > :not(:last-child) {\n      margin-right: 2rem;\n    }\n  }\n\n  &__total {\n    display: grid;\n    grid-template-columns: 1.3fr 1fr;\n    gap: 2rem;\n    margin-bottom: 1rem;\n  }\n\n  &__account {\n    display: grid;\n    grid-template-columns: 1.3fr 1fr;\n    gap: 1rem;\n    margin: 2rem 0;\n  }\n\n  &__button {\n    display: flex;\n    gap: 2rem;\n    align-items: center;\n    margin-top: 2rem;\n  }\n}\n\n//Errors\n\n.error {\n  font-size: var(--default-font-small);\n  color: var(--color-error);\n  padding-left: 2rem;\n  font-weight: 400;\n  margin: 1rem 0;\n}\n\n.select {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  box-sizing: border-box;\n  font-size: var(--default-font-small);\n  width: 38rem;\n\n  margin-bottom: 3rem;\n  cursor: pointer;\n\n  & > * {\n    padding: 1rem 0 1rem 0;\n    text-align: center;\n  }\n\n  &__invoice {\n    background-color: var(--color-primary);\n    color: var(--color-white);\n    border-radius: 1rem 0 0 1rem;\n    transition: all 0.4s;\n\n    &_b {\n      border: 1px solid var(--color-primary);\n      border-radius: 1rem 0 0 1rem;\n      transition: all 0.4s;\n    }\n  }\n\n  &__receipt {\n    border: 1px solid var(--color-primary);\n    border-radius: 0 1rem 1rem 0;\n    transition: all 0.4s;\n\n    &_b {\n      background-color: var(--color-primary);\n      color: var(--color-white);\n      border-radius: 0 1rem 1rem 0;\n      transition: all 0.4s;\n    }\n  }\n}\n\n.selectCurrency {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: var(--default-font-small);\n  position: relative;\n  margin-left: 2rem;\n\n  &__text {\n    display: flex;\n    margin-left: 1rem;\n  }\n\n  &__icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 3rem;\n    background-color: #f2f0f0;\n    color: var(--color-primary);\n    width: 5rem;\n    height: 5rem;\n    border-radius: 5rem;\n    border: solid 1px var(--color-primary-4);\n    cursor: pointer;\n    transform: rotateZ(0);\n    transition-duration: 500ms;\n\n    &:hover {\n      box-shadow:\n        10px 10px 45px #bebebe,\n        -15px -15px 30px #ffffff;\n      background-color: var(--color-primary-3);\n      transform: rotateZ(-180deg);\n    }\n\n    &_active {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: 3rem;\n      background-color: #f2f0f0;\n      color: var(--color-primary);\n      width: 5rem;\n      height: 5rem;\n      border-radius: 5rem;\n      border: solid 1px var(--color-primary-4);\n      cursor: pointer;\n      transition-duration: 500ms;\n      box-shadow:\n        10px 10px 45px #bebebe,\n        -15px -15px 30px #ffffff;\n      background-color: var(--color-primary-3);\n      transform: rotateZ(-180deg);\n    }\n  }\n\n  &__list {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    box-sizing: border-box;\n    width: 5rem;\n    background-color: #f2f0f0;\n    color: var(--color-dark);\n    border-radius: 1rem;\n    box-shadow:\n      10px 10px 45px #bebebe,\n      -15px -15px 30px #ffffff;\n    position: absolute;\n    top: 6rem;\n    z-index: 30;\n    border: solid 1px var(--color-primary-4);\n\n    &_active {\n      background-color: var(--color-primary-7);\n      color: var(--color-primary);\n      font-weight: 700;\n    }\n\n    li {\n      list-style: none;\n      display: flex;\n      justify-content: center;\n      width: 100%;\n      padding: 1rem 0;\n      box-sizing: border-box;\n      border-radius: 1rem;\n      cursor: pointer;\n\n      &:hover {\n        background-color: var(--color-primary-7);\n        color: var(--color-primary);\n        font-weight: 700;\n      }\n    }\n  }\n}\n\n.main {\n  display: grid;\n  grid-template-columns: 72rem 1fr;\n  align-items: center;\n  width: 100%;\n  box-sizing: border-box;\n  gap: 2rem;\n\n  @media only screen and (max-width: $bp-1000) {\n    grid-template-columns: 56rem 1fr;\n  }\n\n  @media only screen and (max-width: $bp-700) {\n    grid-template-columns: 100%;\n  }\n\n  &_nav {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    margin-top: 2rem;\n    padding: 0 2rem;\n    // border-top: solid 1px var(--color-primary);\n    background-color: var(--color-white);\n    border-bottom: solid 1px var(--color-dark);\n    border-radius: 1rem 1rem 0 0;\n\n    & > :not(:last-child) {\n      margin-right: 3rem;\n    }\n\n    &_group {\n      position: relative;\n    }\n\n    &_more {\n      position: absolute;\n      right: 0;\n      top: 75%;\n      background-color: var(--color-white);\n      padding: 1.5rem;\n      border-radius: 1rem;\n      box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n      z-index: 5;\n\n      & > :not(last-child) {\n        margin-bottom: 1rem;\n      }\n    }\n\n    &_item {\n      cursor: pointer;\n      padding: 1rem 0;\n      box-sizing: border-box;\n      font-size: var(--default-font-small);\n\n      // @media only screen and (max-width: $bp-600) {\n      // \twidth: 47%;\n      // }\n\n      &_active {\n        cursor: pointer;\n        padding: 1rem 0;\n        box-sizing: border-box;\n        font-size: var(--default-font-small);\n        font-weight: 700;\n        color: var(--color-fash-primary-3);\n        border-bottom: solid 2px var(--color-fash-primary-3);\n      }\n\n      &:hover,\n      &:focus,\n      &:focus-visible,\n      &:focus-within {\n        font-weight: 700;\n        color: var(--color-fash-primary-3);\n        border-bottom: solid 2px var(--color-fash-primary-3);\n      }\n    }\n  }\n\n  // & > :nth-child(3) {\n  // \tgrid-column: 1/3;\n  // \tgrid-row: 2/3;\n  // }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upper": `Invoice_upper__Gd2b+`,
	"upper__ql": `Invoice_upper__ql__R8j39`,
	"upper__ql__content": `Invoice_upper__ql__content__Ac5yB`,
	"upper__multiple": `Invoice_upper__multiple__aD+dh`,
	"upper__metrics": `Invoice_upper__metrics__OlEPO`,
	"searchInMiddle": `Invoice_searchInMiddle__x2bdb`,
	"invoice__list": `Invoice_invoice__list__n37TC`,
	"invoice__beside": `Invoice_invoice__beside__y1ZH6`,
	"invoice__checks": `Invoice_invoice__checks__2myL2`,
	"invoice__checks_group": `Invoice_invoice__checks_group__c5Apd`,
	"table": `Invoice_table__qu7ns`,
	"notPaid": `Invoice_notPaid__kPzdw`,
	"draft": `Invoice_draft__bcJ1M`,
	"partPaid": `Invoice_partPaid__Gib1L`,
	"expired": `Invoice_expired__SvxXR`,
	"paid": `Invoice_paid__5IJo7`,
	"ordered": `Invoice_ordered__QN3dd`,
	"minMenu": `Invoice_minMenu__+h1v9`,
	"sideButton": `Invoice_sideButton__Kw1Hr`,
	"summary": `Invoice_summary__nH3v3`,
	"summary__title": `Invoice_summary__title__z2RZ-`,
	"summary__initials": `Invoice_summary__initials__CyNRq`,
	"summary__edit": `Invoice_summary__edit__PFPlo`,
	"summary__line": `Invoice_summary__line__rhEwO`,
	"summary__dates": `Invoice_summary__dates__N0WSr`,
	"summary__total": `Invoice_summary__total__ub4r8`,
	"summary__account": `Invoice_summary__account__gM4RU`,
	"summary__button": `Invoice_summary__button__thaN5`,
	"error": `Invoice_error__dIf0C`,
	"select": `Invoice_select__ww0bi`,
	"select__invoice": `Invoice_select__invoice__qyUTR`,
	"select__invoice_b": `Invoice_select__invoice_b__MV0t8`,
	"select__receipt": `Invoice_select__receipt__n+Ypx`,
	"select__receipt_b": `Invoice_select__receipt_b__WC+1+`,
	"selectCurrency": `Invoice_selectCurrency__8og0S`,
	"selectCurrency__text": `Invoice_selectCurrency__text__7qDkA`,
	"selectCurrency__icon": `Invoice_selectCurrency__icon__iU24h`,
	"selectCurrency__icon_active": `Invoice_selectCurrency__icon_active__V7B9V`,
	"selectCurrency__list": `Invoice_selectCurrency__list__KoU7o`,
	"selectCurrency__list_active": `Invoice_selectCurrency__list_active__9BL9c`,
	"main": `Invoice_main__xpYD+`,
	"main_nav": `Invoice_main_nav__aBLu+`,
	"main_nav_group": `Invoice_main_nav_group__Ui7tJ`,
	"main_nav_more": `Invoice_main_nav_more__JU6Hi`,
	"main_nav_item": `Invoice_main_nav_item__PdYIx`,
	"main_nav_item_active": `Invoice_main_nav_item_active__ruq3t`
};
export default ___CSS_LOADER_EXPORT___;
